import { axiosBaseQuery } from "@king-ict/eupisi-ui/utils";
import { createApi } from "@reduxjs/toolkit/query/react";

import { CommitteeResponse, RegionalCommittee } from "../models/Committee";

export const committeeApi = createApi({
  reducerPath: "committeeApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["InstitutionCountyCommittee", "RegionalCommittee"],
  endpoints: (build) => ({
    getInstitutionCountyCommittee: build.query<CommitteeResponse, number>({
      query: (requestId: number) => ({
        url: `request/get-institution-county-committees/${requestId}`,
      }),
    }),
    getRegionalCommitteeById: build.query<RegionalCommittee, number>({
      query: (id: number) => ({
        url: `regional-committee/get/${id}`,
      }),
    }),
  }),
});

export const {
  useGetInstitutionCountyCommitteeQuery,
  useGetRegionalCommitteeByIdQuery,
} = committeeApi;
